<template>
  <section class="sign-in-page">
    <div id="container-inside">
      <div id="circle-small"></div>
      <div id="circle-medium"></div>
      <div id="circle-large"></div>
      <div id="circle-xlarge"></div>
      <div id="circle-xxlarge"></div>
    </div>
    <div class="container p-0">
      <div class="row no-gutters">
        <div class="col-md-6 text-center pt-5">
          <div class="sign-in-detail text-white">
            <a class="sign-in-logo mb-5" href="#"><img src="@/assets/images/logo-full.png" class="img-fluid" alt="logo"></a>
            <Swiper :options="options">
              <SwiperSlide  class="item">
                <img src="@/assets/images/login/1.png" class="img-fluid mb-4" alt="logo">
                <h4 class="mb-1 text-white">Yönet</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus mauris a nibh sodales, nec congue</p>
              </SwiperSlide>
              <SwiperSlide class="item">
                <img src="@/assets/images/login/2.png" class="img-fluid mb-4" alt="logo">
                <h4 class="mb-1 text-white">Yönet</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus mauris a nibh sodales, nec congue</p>
              </SwiperSlide>
              <SwiperSlide class="item">
                <img src="@/assets/images/login/3.png" class="img-fluid mb-4" alt="logo">
                <h4 class="mb-1 text-white">Yönet</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus mauris a nibh sodales, nec congue</p>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div class="col-sm-6 bg-white pt-5">
          <div class="sign-in-from">
            <h1 class="mb-0">Giriş Yap</h1>
            <p>Daha fazlasına erişmek için giriş yap.</p>
            <form class="mt-4" @submit.prevent="onSubmit()">
                <div class="form-group">
                    <label class="form-label" for="exampleInputEmail1">Email</label>
                    <input type="email" v-model="loginInfo.email" class="form-control mb-0" id="exampleInputEmail1" placeholder="Enter email">
                </div>
                <div class="form-group">
                    <label class="form-label" for="exampleInputPassword1">Şifre</label>
                    <router-link :to="{ name: 'auth1.recoverpassword1'}" class="float-end">Şifreni mi unuttun ?</router-link>
                    <input type="password" v-model="loginInfo.password" class="form-control mb-0" id="exampleInputPassword1" placeholder="Password">
                </div>
                <div class="d-inline-block w-100">
                    <div class="form-check d-inline-block mt-2 pt-1">
                        <input type="checkbox" class="form-check-input" id="customCheck11">
                        <label class="form-check-label" for="customCheck11">Beni hatırla</label>
                    </div>
                    <button type="submit" class="btn btn-primary float-end">Giriş Yap</button>
                </div>
                <div class="sign-info">
                    <span class="dark-color d-inline-block line-height-2">Hesabın yok mu?<router-link :to="{ name: 'auth1.sign-up1'}"> Kayıt ol</router-link></span>
                    <ul class="iq-social-media">
                        <li><a href="#"><i class="ri-facebook-box-line"></i></a></li>
                        <li><a href="#"><i class="ri-twitter-line"></i></a></li>
                        <li><a href="#"><i class="ri-instagram-line"></i></a></li>
                    </ul>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from '../../../components/custom/slider/Swiper'
import SwiperSlide from '../../../components/custom/slider/SwiperSlide'
export default {
  name: 'SignIn1',
  components: { Swiper, SwiperSlide },
  data () {
    return {
      options: {
        centeredSlides: false,
        loop: false,
        slidesPerView: 1,
        autoplay: {
          delay: 3000
        },
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar'
        }
      },
      loginInfo: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    onSubmit () {
      this.$store.dispatch('friendsquads/signIn', this.loginInfo)
    }
  }
}
</script>
